var map = {
	"./sv/antagonists-adoptivedad-statements-0.mp3": [
		46469,
		6469
	],
	"./sv/antagonists-adoptivedad-winquote.mp3": [
		84075,
		4075
	],
	"./sv/antagonists-adult-statements-0.mp3": [
		69709,
		9709
	],
	"./sv/antagonists-adult-winquote.mp3": [
		19846,
		9846
	],
	"./sv/antagonists-bigsister-statements-0.mp3": [
		52557,
		2557
	],
	"./sv/antagonists-bigsister-statements-1.mp3": [
		65619,
		5619
	],
	"./sv/antagonists-bigsister-statements-winquote.mp3": [
		84338,
		4338
	],
	"./sv/antagonists-borderpolice-statements-0.mp3": [
		2714,
		2714
	],
	"./sv/antagonists-borderpolice-winquote.mp3": [
		61,
		61
	],
	"./sv/antagonists-cashier-statements-0.mp3": [
		82093,
		2093
	],
	"./sv/antagonists-cashier-statements-1.mp3": [
		24634,
		4634
	],
	"./sv/antagonists-cashier-winquote.mp3": [
		2558,
		2558
	],
	"./sv/antagonists-classmate1-statements-0.mp3": [
		18158,
		8158
	],
	"./sv/antagonists-classmate1-statements-1.mp3": [
		53685,
		3685
	],
	"./sv/antagonists-classmate1-winquote.mp3": [
		65188,
		5188
	],
	"./sv/antagonists-classmate2-statements-0.mp3": [
		19949,
		9949
	],
	"./sv/antagonists-classmate2-statements-1.mp3": [
		35674,
		5674
	],
	"./sv/antagonists-classmate2-winquote.mp3": [
		47221,
		7221
	],
	"./sv/antagonists-coach-statements-0.mp3": [
		58775,
		8775
	],
	"./sv/antagonists-coach-statements-1.mp3": [
		43811,
		3811
	],
	"./sv/antagonists-coach-winquote.mp3": [
		82944,
		2944
	],
	"./sv/antagonists-dad-statements-0.mp3": [
		35438,
		5438
	],
	"./sv/antagonists-dad-statements-1.mp3": [
		24943,
		4943
	],
	"./sv/antagonists-dad-statements-2.mp3": [
		24068,
		4068
	],
	"./sv/antagonists-dad-winquote.mp3": [
		53296,
		3296
	],
	"./sv/antagonists-drunkparent-statements-0.mp3": [
		59729,
		9729
	],
	"./sv/antagonists-drunkparent-statements-1.mp3": [
		22680,
		2680
	],
	"./sv/antagonists-drunkparent-winquote.mp3": [
		88154,
		8154
	],
	"./sv/antagonists-foreigndad-statements-0.mp3": [
		18595,
		8595
	],
	"./sv/antagonists-foreigndad-winquote.mp3": [
		27316,
		7316
	],
	"./sv/antagonists-friend-statements-0.mp3": [
		20353,
		353
	],
	"./sv/antagonists-friend-statements-1.mp3": [
		1237,
		1237
	],
	"./sv/antagonists-friend-winquote.mp3": [
		60797,
		797
	],
	"./sv/antagonists-gang-statements-0.mp3": [
		9009,
		9009
	],
	"./sv/antagonists-gang-statements-1.mp3": [
		29897,
		9897
	],
	"./sv/antagonists-gang-winquote.mp3": [
		93355,
		3355
	],
	"./sv/antagonists-groomer-statements-0.mp3": [
		52988,
		2988
	],
	"./sv/antagonists-groomer-statements-1.mp3": [
		92976,
		2976
	],
	"./sv/antagonists-groomer-winquote.mp3": [
		33723,
		3723
	],
	"./sv/antagonists-grownup-statements-0.mp3": [
		83406,
		3406
	],
	"./sv/antagonists-grownup-statements-1.mp3": [
		88414,
		8414
	],
	"./sv/antagonists-grownup-winquote.mp3": [
		15953,
		5953
	],
	"./sv/antagonists-gymteacher-statements-0.mp3": [
		71862,
		1862
	],
	"./sv/antagonists-gymteacher-statements-1.mp3": [
		71287,
		1287
	],
	"./sv/antagonists-gymteacher-winquote.mp3": [
		96160,
		6160
	],
	"./sv/antagonists-homophobicadult-statements-0.mp3": [
		76588,
		6588
	],
	"./sv/antagonists-homophobicadult-winquote.mp3": [
		80213,
		213
	],
	"./sv/antagonists-league-statements-0.mp3": [
		11998,
		1998
	],
	"./sv/antagonists-league-statements-1.mp3": [
		16339,
		6339
	],
	"./sv/antagonists-league-winquote.mp3": [
		68465,
		8465
	],
	"./sv/antagonists-mum-statements-0.mp3": [
		42075,
		2075
	],
	"./sv/antagonists-mum-statements-1.mp3": [
		11771,
		1771
	],
	"./sv/antagonists-mum-winquote.mp3": [
		22250,
		2250
	],
	"./sv/antagonists-mumtodisabledchild-statements-0.mp3": [
		31198,
		1198
	],
	"./sv/antagonists-mumtodisabledchild-statements-1.mp3": [
		87483,
		7483
	],
	"./sv/antagonists-mumtodisabledchild-winquote.mp3": [
		38781,
		8781
	],
	"./sv/antagonists-noopinionsdad-statements-0.mp3": [
		46763,
		6763
	],
	"./sv/antagonists-noopinionsdad-statements-1.mp3": [
		97554,
		7554
	],
	"./sv/antagonists-noopinionsdad-statements-2.mp3": [
		53779,
		3779
	],
	"./sv/antagonists-noopinionsdad-winquote.mp3": [
		96845,
		6845
	],
	"./sv/antagonists-parentsdivorcing-statements-0.mp3": [
		51789,
		1789
	],
	"./sv/antagonists-parentsdivorcing-statements-1.mp3": [
		28960,
		8960
	],
	"./sv/antagonists-parentsdivorcing-statements-2.mp3": [
		98071,
		8071
	],
	"./sv/antagonists-parentsdivorcing-winquote.mp3": [
		23465,
		3465
	],
	"./sv/antagonists-politician-statements-0.mp3": [
		10010,
		10
	],
	"./sv/antagonists-politician-statements-1.mp3": [
		3717,
		3717
	],
	"./sv/antagonists-politician-winquote.mp3": [
		71979,
		1979
	],
	"./sv/antagonists-racistteacher-statements-0.mp3": [
		20963,
		963
	],
	"./sv/antagonists-racistteacher-statements-1.mp3": [
		53924,
		3924
	],
	"./sv/antagonists-racistteacher-statements-2.mp3": [
		17991,
		7991
	],
	"./sv/antagonists-racistteacher-winquote.mp3": [
		4736,
		4736
	],
	"./sv/antagonists-relative-statements-0.mp3": [
		12357,
		2357
	],
	"./sv/antagonists-relative-statements-1.mp3": [
		62898,
		2898
	],
	"./sv/antagonists-relative-winquote.mp3": [
		29013,
		9013
	],
	"./sv/antagonists-salesperson-statements-0.mp3": [
		65449,
		5449
	],
	"./sv/antagonists-salesperson-statements-1.mp3": [
		25842,
		5842
	],
	"./sv/antagonists-salesperson-winquote.mp3": [
		18626,
		8626
	],
	"./sv/antagonists-sibling-statements-0.mp3": [
		64817,
		4817
	],
	"./sv/antagonists-sibling-statements-1.mp3": [
		92017,
		2017
	],
	"./sv/antagonists-sibling-winquote.mp3": [
		44213,
		4213
	],
	"./sv/antagonists-teacher-statements-0.mp3": [
		95813,
		5813
	],
	"./sv/antagonists-teacher-statements-1.mp3": [
		98407,
		8407
	],
	"./sv/antagonists-teacher-winquote.mp3": [
		90919,
		919
	],
	"./sv/antagonists-teacherEnvironment-statements-0.mp3": [
		60097,
		97
	],
	"./sv/antagonists-teacherEnvironment-statements-1.mp3": [
		31343,
		1343
	],
	"./sv/antagonists-teacherEnvironment-winquote.mp3": [
		91369,
		1369
	],
	"./sv/antagonists-troll-statements-0.mp3": [
		40295,
		295
	],
	"./sv/antagonists-troll-winquote.mp3": [
		81885,
		1885
	],
	"./sv/cards-1-back-heading.mp3": [
		57696,
		7696
	],
	"./sv/cards-1-front.mp3": [
		29700,
		9700
	],
	"./sv/cards-10-back-heading.mp3": [
		28815,
		8815
	],
	"./sv/cards-10-front.mp3": [
		75141,
		5141
	],
	"./sv/cards-11a-back-heading.mp3": [
		64348,
		4348
	],
	"./sv/cards-11a-front.mp3": [
		69235,
		9235
	],
	"./sv/cards-12a-back-heading.mp3": [
		95715,
		5715
	],
	"./sv/cards-12a-front.mp3": [
		19082,
		9082
	],
	"./sv/cards-12b-back-heading.mp3": [
		50029,
		29
	],
	"./sv/cards-12b-front.mp3": [
		21714,
		1714
	],
	"./sv/cards-13a-back-heading.mp3": [
		48771,
		8771
	],
	"./sv/cards-13a-front.mp3": [
		39214,
		9214
	],
	"./sv/cards-13b-back-heading.mp3": [
		50549,
		549
	],
	"./sv/cards-13b-front.mp3": [
		13346,
		3346
	],
	"./sv/cards-13c-back-heading.mp3": [
		57398,
		7398
	],
	"./sv/cards-13c-front.mp3": [
		43452,
		3452
	],
	"./sv/cards-14a-back-heading.mp3": [
		85334,
		5334
	],
	"./sv/cards-14a-front.mp3": [
		71522,
		1522
	],
	"./sv/cards-14b-back-heading.mp3": [
		90052,
		52
	],
	"./sv/cards-14b-front.mp3": [
		37351,
		7351
	],
	"./sv/cards-15-back-heading.mp3": [
		24290,
		4290
	],
	"./sv/cards-15-front.mp3": [
		8682,
		8682
	],
	"./sv/cards-16a-back-heading.mp3": [
		35722,
		5722
	],
	"./sv/cards-16a-front.mp3": [
		14211,
		4211
	],
	"./sv/cards-16b-back-heading.mp3": [
		17795,
		7795
	],
	"./sv/cards-16b-front.mp3": [
		75050,
		5050
	],
	"./sv/cards-16c-back-heading.mp3": [
		99129,
		9129
	],
	"./sv/cards-16c-front.mp3": [
		39529,
		9529
	],
	"./sv/cards-17-back-heading.mp3": [
		99677,
		9677
	],
	"./sv/cards-17-front.mp3": [
		64358,
		4358
	],
	"./sv/cards-18-back-heading.mp3": [
		72698,
		2698
	],
	"./sv/cards-18-front.mp3": [
		67502,
		7502
	],
	"./sv/cards-19a-back-heading.mp3": [
		35870,
		5870
	],
	"./sv/cards-19a-front.mp3": [
		80546,
		546
	],
	"./sv/cards-19b-back-heading.mp3": [
		19022,
		9022
	],
	"./sv/cards-19b-front.mp3": [
		25034,
		5034
	],
	"./sv/cards-20-back-heading.mp3": [
		89729,
		1352
	],
	"./sv/cards-20-front.mp3": [
		36516,
		6516
	],
	"./sv/cards-21-back-heading.mp3": [
		71980,
		1980
	],
	"./sv/cards-21-front.mp3": [
		93303,
		3303
	],
	"./sv/cards-22a-back-heading.mp3": [
		45545,
		5545
	],
	"./sv/cards-22a-front.mp3": [
		30931,
		931
	],
	"./sv/cards-23a-back-heading.mp3": [
		58364,
		8364
	],
	"./sv/cards-23a-front.mp3": [
		42480,
		2480
	],
	"./sv/cards-24a-back-heading.mp3": [
		8648,
		8648
	],
	"./sv/cards-24a-front.mp3": [
		65374,
		5374
	],
	"./sv/cards-24b-back-heading.mp3": [
		18700,
		8700
	],
	"./sv/cards-24b-front.mp3": [
		65253,
		5253
	],
	"./sv/cards-25-back-heading.mp3": [
		55070,
		5070
	],
	"./sv/cards-25-front.mp3": [
		2288,
		2288
	],
	"./sv/cards-26-back-heading.mp3": [
		8039,
		8039
	],
	"./sv/cards-26-front.mp3": [
		52864,
		2864
	],
	"./sv/cards-27a-back-heading.mp3": [
		21230,
		7644
	],
	"./sv/cards-27a-front.mp3": [
		54506,
		4506
	],
	"./sv/cards-27b-back-heading.mp3": [
		16530,
		6530
	],
	"./sv/cards-27b-front.mp3": [
		57008,
		7008
	],
	"./sv/cards-27c-back-heading.mp3": [
		14341,
		4341
	],
	"./sv/cards-27c-front.mp3": [
		15286,
		5286
	],
	"./sv/cards-28a-back-heading.mp3": [
		26288,
		6288
	],
	"./sv/cards-28a-front.mp3": [
		97250,
		7250
	],
	"./sv/cards-28b-back-heading.mp3": [
		20299,
		299
	],
	"./sv/cards-28b-front.mp3": [
		27363,
		7363
	],
	"./sv/cards-29a-back-heading.mp3": [
		72714,
		3205
	],
	"./sv/cards-29a-front.mp3": [
		67765,
		7765
	],
	"./sv/cards-29b-back-heading.mp3": [
		94129,
		4129
	],
	"./sv/cards-29b-front.mp3": [
		82544,
		2544
	],
	"./sv/cards-29c-back-heading.mp3": [
		82171,
		2171
	],
	"./sv/cards-29c-front.mp3": [
		79371,
		9371
	],
	"./sv/cards-2a-back-heading.mp3": [
		70841,
		841
	],
	"./sv/cards-2a-front.mp3": [
		94029,
		4029
	],
	"./sv/cards-2b-back-heading.mp3": [
		72252,
		2252
	],
	"./sv/cards-2b-front.mp3": [
		37668,
		7668
	],
	"./sv/cards-2c-back-heading.mp3": [
		56063,
		6063
	],
	"./sv/cards-2c-front.mp3": [
		17183,
		7183
	],
	"./sv/cards-2d-back-heading.mp3": [
		68910,
		8910
	],
	"./sv/cards-2d-front.mp3": [
		30654,
		654
	],
	"./sv/cards-2e-back-heading.mp3": [
		37093,
		7093
	],
	"./sv/cards-2e-front.mp3": [
		13840,
		3840
	],
	"./sv/cards-30a-back-heading.mp3": [
		95989,
		5989
	],
	"./sv/cards-30a-front.mp3": [
		12146,
		2146
	],
	"./sv/cards-30b-back-heading.mp3": [
		54635,
		4635
	],
	"./sv/cards-30b-front.mp3": [
		8019,
		8019
	],
	"./sv/cards-30c-back-heading.mp3": [
		60479,
		479
	],
	"./sv/cards-30c-front.mp3": [
		22587,
		2587
	],
	"./sv/cards-31a-back-heading.mp3": [
		6472,
		6472
	],
	"./sv/cards-31a-front.mp3": [
		59711,
		9711
	],
	"./sv/cards-31b-back-heading.mp3": [
		95449,
		5873
	],
	"./sv/cards-31b-front.mp3": [
		31002,
		1002
	],
	"./sv/cards-31c-back-heading.mp3": [
		52071,
		2071
	],
	"./sv/cards-31c-front.mp3": [
		69670,
		9670
	],
	"./sv/cards-32-back-heading.mp3": [
		37828,
		7828
	],
	"./sv/cards-32-front.mp3": [
		42652,
		2652
	],
	"./sv/cards-33a-back-heading.mp3": [
		13221,
		3221
	],
	"./sv/cards-33a-front.mp3": [
		90352,
		352
	],
	"./sv/cards-34-back-heading.mp3": [
		30209,
		209
	],
	"./sv/cards-34-front.mp3": [
		29933,
		9933
	],
	"./sv/cards-35-back-heading.mp3": [
		27214,
		7214
	],
	"./sv/cards-35-front.mp3": [
		68789,
		8789
	],
	"./sv/cards-36-back-heading.mp3": [
		44414,
		4414
	],
	"./sv/cards-36-front.mp3": [
		7658,
		7658
	],
	"./sv/cards-37a-back-heading.mp3": [
		38702,
		8702
	],
	"./sv/cards-37a-front.mp3": [
		45565,
		5565
	],
	"./sv/cards-37b-back-heading.mp3": [
		12474,
		2474
	],
	"./sv/cards-37b-front.mp3": [
		23192,
		3192
	],
	"./sv/cards-37c-back-heading.mp3": [
		97710,
		7710
	],
	"./sv/cards-37c-front.mp3": [
		47713,
		7713
	],
	"./sv/cards-38-back-heading.mp3": [
		5693,
		5693
	],
	"./sv/cards-38-front.mp3": [
		45929,
		5929
	],
	"./sv/cards-39-back-heading.mp3": [
		20083,
		83
	],
	"./sv/cards-39-front.mp3": [
		65356,
		5356
	],
	"./sv/cards-3a-back-heading.mp3": [
		58065,
		8065
	],
	"./sv/cards-3a-front.mp3": [
		80246,
		246
	],
	"./sv/cards-3b-back-heading.mp3": [
		30330,
		330
	],
	"./sv/cards-3b-front.mp3": [
		81971,
		1971
	],
	"./sv/cards-40a-back-heading.mp3": [
		7733,
		7733
	],
	"./sv/cards-40a-front.mp3": [
		27546,
		7546
	],
	"./sv/cards-40b-back-heading.mp3": [
		53007,
		3007
	],
	"./sv/cards-40b-front.mp3": [
		62893,
		2893
	],
	"./sv/cards-41-back-heading.mp3": [
		15717,
		5717
	],
	"./sv/cards-41-front.mp3": [
		91958,
		1958
	],
	"./sv/cards-42-back-heading.mp3": [
		36352,
		6352
	],
	"./sv/cards-42-front.mp3": [
		92592,
		2592
	],
	"./sv/cards-4a-back-heading.mp3": [
		81102,
		1102
	],
	"./sv/cards-4a-front.mp3": [
		56348,
		6348
	],
	"./sv/cards-5-back-heading.mp3": [
		77933,
		7933
	],
	"./sv/cards-5-front.mp3": [
		75355,
		5355
	],
	"./sv/cards-6a-back-heading.mp3": [
		94539,
		4539
	],
	"./sv/cards-6a-front.mp3": [
		99795,
		9795
	],
	"./sv/cards-6b-back-heading.mp3": [
		68051,
		8051
	],
	"./sv/cards-6b-front.mp3": [
		70954,
		954
	],
	"./sv/cards-7a-back-heading.mp3": [
		93720,
		7268
	],
	"./sv/cards-7a-front.mp3": [
		85318,
		5318
	],
	"./sv/cards-7b-back-heading.mp3": [
		44336,
		4336
	],
	"./sv/cards-7b-front.mp3": [
		15375,
		5375
	],
	"./sv/cards-7c-back-heading.mp3": [
		88749,
		8749
	],
	"./sv/cards-7c-front.mp3": [
		76521,
		6521
	],
	"./sv/cards-8-back-heading.mp3": [
		61520,
		1520
	],
	"./sv/cards-8-front.mp3": [
		46362,
		6362
	],
	"./sv/cards-9a-back-heading.mp3": [
		53546,
		3546
	],
	"./sv/cards-9a-front.mp3": [
		3083,
		3083
	],
	"./sv/common-owl-alldefeatedcollection-heading.mp3": [
		30080,
		80
	],
	"./sv/common-owl-alldefeatedhand-heading.mp3": [
		24845,
		4845
	],
	"./sv/common-owl-enablecard-heading.mp3": [
		34665,
		4665
	],
	"./sv/common-owl-flipcardtip-heading.mp3": [
		30094,
		94
	],
	"./sv/common-owl-homewelcome-text_1-heading.mp3": [
		93958,
		3958
	],
	"./sv/common-owl-homewelcome-text_2-body.mp3": [
		62903,
		2903
	],
	"./sv/common-owl-homewelcome-text_3-body.mp3": [
		34598,
		4598
	],
	"./sv/common-owl-homewelcome-text_4-body.mp3": [
		50451,
		451
	],
	"./sv/common-owl-intro-heading.mp3": [
		62113,
		2113
	],
	"./sv/common-owl-lootbox-bought2-heading.mp3": [
		10566,
		566
	],
	"./sv/common-owl-lootbox-item-body.mp3": [
		3698,
		3698
	],
	"./sv/common-owl-lootbox-itemonly-heading.mp3": [
		50395,
		395
	],
	"./sv/common-owl-lootbox-start-heading.mp3": [
		88863,
		8863
	],
	"./sv/common-owl-lootbox-won1-heading.mp3": [
		33386,
		3386
	],
	"./sv/common-owl-lootbox-won2-heading.mp3": [
		88109,
		8109
	],
	"./sv/common-owl-maxcards-heading.mp3": [
		66863,
		6863
	],
	"./sv/common-owl-noplayablescenarios-heading.mp3": [
		38182,
		8182
	],
	"./sv/common-owl-nounplayedscenarios-heading.mp3": [
		61542,
		1542
	],
	"./sv/common-owl-persuasiondone-losstext-header.mp3": [
		99193,
		9193
	],
	"./sv/common-owl-persuasiondone-winall-heading.mp3": [
		63486,
		3486
	],
	"./sv/common-owl-persuasiondone-winscenariomode-heading.mp3": [
		46637,
		6637
	],
	"./sv/common-owl-play-heading.mp3": [
		96282,
		6282
	],
	"./sv/common-owl-quiztip-heading.mp3": [
		87706,
		7706
	],
	"./sv/common-owl-resetgame-header.mp3": [
		31217,
		1217
	],
	"./sv/common-owl-secondchallenge-heading.mp3": [
		66851,
		6851
	],
	"./sv/common-owl-startplaytip-body.mp3": [
		56792,
		6792
	],
	"./sv/common-owl-suggesthand-heading.mp3": [
		32418,
		2418
	],
	"./sv/common-owl-token-heading.mp3": [
		74487,
		4487
	],
	"./sv/common-persuasion-genericwrongcardanswers-answer_1-text.mp3": [
		3736,
		3736
	],
	"./sv/common-persuasion-genericwrongcardanswers-answer_2-text.mp3": [
		48146,
		8146
	],
	"./sv/common-persuasion-genericwrongcardanswers-answer_3-text.mp3": [
		27448,
		7448
	],
	"./sv/common-persuasion-genericwrongcardanswers-answer_4-text.mp3": [
		47581,
		7581
	],
	"./sv/common-persuasion-genericwrongcardanswers-answer_5-text.mp3": [
		94424,
		4424
	],
	"./sv/common-persuasion-genericwrongcardanswers-answer_6-text.mp3": [
		60522,
		522
	],
	"./sv/owl/owl-wintext_1.mp3": [
		68969,
		8969
	],
	"./sv/owl/owl-wintext_2.mp3": [
		72313,
		2313
	],
	"./sv/owl/owl-wintext_3.mp3": [
		86244,
		6244
	],
	"./sv/owl/owl-wintext_4.mp3": [
		33201,
		3201
	],
	"./sv/owl/owl-wintext_5.mp3": [
		6083,
		6083
	],
	"./sv/owl/owl-wintext_6.mp3": [
		6146,
		6146
	],
	"./sv/owl/owl-wintext_7.mp3": [
		25092,
		3720
	],
	"./sv/owl/owl-wintext_8.mp3": [
		24051,
		4051
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 41019;
module.exports = webpackAsyncContext;